import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import LoadingText from '@components/LoadingText'

export default function SkeletonSuspense({lines = 1, loading = true, children}) {
  const fallback = () => {
    return <LoadingText lines={lines} />
  }

  if (loading) {
    return fallback()
  }

  return <ClientSuspense fallback={fallback}>{children}</ClientSuspense>
}
